import cx from 'classnames';
import styles from './FooterCard.module.scss';
import { Paragraph } from 'ui/components/1-atoms/Paragraph';

export interface FooterCardProps {
	heading?: string;
	className?: string;
	children?: React.ReactNode;
	theme?: UI.GeneralColorTheme;
}

export const FooterCard: React.FC<FooterCardProps> = ({ className, children, heading, theme = 'dark' }) => (
	<div className={cx(styles.FooterCard, styles[`FooterCard___theme-${theme}`], className)}>
		<div className={styles.FooterCard_textbox}>
			{heading && (
				<Paragraph id={heading} size="md" className={styles.FooterCard_heading}>
					{heading}
				</Paragraph>
			)}
			<div className={styles.FooterCard_content}>{children}</div>
		</div>
	</div>
);
